import { render, staticRenderFns } from "./deleteProject.vue?vue&type=template&id=495b1833&scoped=true&"
import script from "./deleteProject.vue?vue&type=script&lang=js&"
export * from "./deleteProject.vue?vue&type=script&lang=js&"
import style0 from "./deleteProject.vue?vue&type=style&index=0&id=495b1833&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b1833",
  null
  
)

export default component.exports